import axios from "axios";
import {
  ACCEPT_APPOINTMENT,
  ACTIVATE_CLINIC,
  ADD_PET,
  ADD_PET_TO_USER,
  BOOKING,
  CLINICS,
  CLINICS_EDITING,
  DEACTIVATE_CLINIC,
  PRICES_BASE_REQUEST,
  REJECT_APPOINTMENT,
  SPECIES_SAVE,
  TEMPLATE,
  TREATMENT,
  PET_NOTE_SUBMIT,
} from "../ApiPaths";
import authApi from "../../utils/api/authApi";
import logger from "../../utils/logger";

//Core function for submitting data with react query
//Create a parent function for each submit to handle data
export async function submit(path, formData) {
  try {
    const res = await authApi.post(path, formData);

    return res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Log and rethrow the actual response from the backend
      const backendMessage =
        error.response?.data || "Unknown error from server";
      throw backendMessage;
    } else {
      logger.error("Unexpected error:", error);
      throw "Unexpected error occurred";
    }
  }
}

export async function submitPut(path, formData) {
  try {
    const res = await authApi.put(path, formData);

    return res;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Log and rethrow the actual response from the backend
      const backendMessage =
        error.response?.data || "Unknown error from server";
      throw backendMessage;
    } else {
      logger.error("Unexpected error:", error);
      throw "Unexpected error occurred";
    }
  }
}

export async function returnSubmit(path, formData) {
  return submit(path, formData); // DRY approach
}

export async function submitPet(data, userId, loggedInUserId) {
  const url = userId ? ADD_PET_TO_USER + userId : ADD_PET + loggedInUserId;
  return await submit(url, data);
}

export async function postClinic(data) {
  try {
    await authApi.post(CLINICS, data);
  } catch (error) {
    throw error;
  }
}

export async function postEmployee(data) {
  const url = "/user/clinic";
  return await submit(url, data);
}

export async function putClinic(data) {
  const url = CLINICS_EDITING;
  return await submit(url, data);
}

export async function clinicActivation(clinic) {
  try {
    const url = clinic.active ? DEACTIVATE_CLINIC : ACTIVATE_CLINIC;
    let res = await authApi.post(url + clinic.id, "activate");
  } catch (error) {
    throw error;
  }
}

export async function submitAppointment(data, loggedInUserId) {
  const url = BOOKING + loggedInUserId;
  return await submit(url, data);
}

export async function submitTreatment(data, id) {
  const url = TREATMENT + id;
  return await submit(url, data);
}

export async function submitFile(data, appointment_id) {
  const url = "/file/upload/appointment/list/" + appointment_id;
  return await submit(url, data);
}

export async function submitTemplate(data, clinicId) {
  const url = TEMPLATE + clinicId;
  return await submit(url, data);
}

export async function submitSpecies(data) {
  const url = SPECIES_SAVE;
  return await submit(url, data);
}

export async function sumbitService(data, clinicId) {
  const url = PRICES_BASE_REQUEST + clinicId;
  return await submit(url, data);
}

export async function acceptAppointment(data, appointmentId) {
  const url = ACCEPT_APPOINTMENT + appointmentId;
  return await submit(url, data);
}

export async function rejectAppointment(data, appointmentId) {
  const url = REJECT_APPOINTMENT + appointmentId + "?statusMessage=" + data;
  return await submit(url, null);
}
export async function submitNote(data, petId) {
  const url = PET_NOTE_SUBMIT + petId;
  return await submit(url, data);
}
